<template>
  <div class="cpunk_page" style="position: relative">
    <div class="creation-process">
      <img class="content" src="~@static/funding_cpunk/tip2.png" />
    </div>
    <div class="create_btn_s1" v-if="noLogin" @click="toLogin"># 立即开造 #</div>
    <div v-else class="create_btn_s1" @click="bindToBegin"># 现在就开造 #</div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: '',
  data() {
    return {}
  },
  computed: {
    ...mapState(['authorization']),
    noLogin() {
      return !this.authorization || this.authorization == ''
    },
  },
  created() {},
  methods: {
    bindToBegin() {
      this.$router.push({ path: '/fundingnew/creation/step1', query: this.$route.query })
      _jcq.push(['_track', 'yjhbccreate'])
    },
    toLogin() {
      this.$router.push(`/login?redirect=${encodeURIComponent(this.$route.fullPath)}`)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@styles/cpunk.scss';
.cpunk_page {
  padding-top: pxtow(169);
  padding-bottom: pxtow(100);
}

.creation-process {
  position: relative;
}

.creation-process .content {
  width: pxtow(526);
  display: block;
  margin: 0 auto;
}
.create_btn_s1 {
  margin-top: pxtow(140) !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/fundingnew/MoreTips.vue